import {Pipe, PipeTransform} from '@angular/core';
import {ICruiseDetailSolution} from '../interfaces/icruise-detail-solution';
import groupBy from '../../../../../utils/groupBy';
import minBy from '../../../../../utils/minBy';
import * as dayjs from 'dayjs';

@Pipe({
  name: 'cruiseSolutionsGroupedByDate'
})
export class CruiseSolutionsGroupedByDatePipe implements PipeTransform {

  transform(value: ICruiseDetailSolution[], hasPromoCosta: boolean): any {
    const solutions = (value) ? JSON.parse(JSON.stringify(value)) : [];

    if (value) {
      let solutionsGrouped = {};

      try {
        // prima di effettuare un raggruppamento per data, ordino le solution dalla data di partenza piu vicina
        const solutionsSortedByDepartureDate = solutions
            .sort((a, b) => dayjs(a.departureDate).unix() - dayjs(b.departureDate).unix());

        // raggruppo per data di partenza e arrivo (recuperate dalle solution disponibili)
        solutionsGrouped = groupBy(solutionsSortedByDepartureDate, (sol) => `${dayjs(sol.departureDate).format('YYYY-MM-DD')}|${dayjs(sol.arrivalDate).format('YYYY-MM-DD')}`);

        // ciclo le solutions raggruppate per data di partenza e arrivo
        for (const departureAndArrivalDate in solutionsGrouped) {
          if (solutionsGrouped.hasOwnProperty(departureAndArrivalDate)) {
            // dall'array di solutions con data di partenza e arrivo specifica, estraggo quella con il prezzo piu
            // basso (in modo da evitare possibili solutions duplicate) e la riassegno sovrascrivendo l'array
            solutionsGrouped[departureAndArrivalDate] = minBy(solutionsGrouped[departureAndArrivalDate], 'price');

            // ordino prima le cabine per prezzo piu basso ed escludo quelle che non hanno alcun "type" impostato
            solutionsGrouped[departureAndArrivalDate].cabins = solutionsGrouped[departureAndArrivalDate].cabins
                .sort((a, b) => (a > b) ? 1 : -1)
                .filter((cabin) => cabin.type);
          }
        }
      } catch (err) {
        console.error(err);
      }

      return solutionsGrouped;
    }

    return {};
  }

}
